import React from 'react'
import { ButtonPrimary, ColoredIllustrationErrorExplodingBalloon } from '@klarna/bubble-ui'
import DialogUnwrapped from 'common/components/dialog-unwrapped'
import CenteredContent from 'common/components/centered-content'
import IssuerLogo from 'common/components/issuer-logo'
import useTranslate from 'common/hooks/use-translate'
import useEligibilityPaymentMethodCategoryAwareTranslate from 'common/hooks/use-eligibility-payment-method-category-aware-translate'
import currency from 'common/utils/currency'

function InvalidAmount({
  amount,
  max,
  min,
  onClose
}: {
  amount: string
  max: number
  min: number
  onClose: Function
}) {
  const translate = useTranslate()
  const eligibilityPaymentMethodCategoryAwareTranslate = useEligibilityPaymentMethodCategoryAwareTranslate()

  return (
    <DialogUnwrapped
      id="invalid-amount-dialog"
      title={<IssuerLogo asDialogTitle />}
      onClose={onClose}
      footer={[
        {
          Component: ButtonPrimary,
          props: {
            id: 'close-button',
            children: translate('eligibility.pre_assessment.invalid_amount.close'),
            onClick: onClose
          }
        }
      ]}
    >
      <CenteredContent
        id="invalid-amount-content"
        illustration={<ColoredIllustrationErrorExplodingBalloon />}
        title={eligibilityPaymentMethodCategoryAwareTranslate(
          'eligibility.pre_assessment.invalid_amount.title',
          {
            amount: currency.format(amount, true)
          }
        )}
        summary={eligibilityPaymentMethodCategoryAwareTranslate(
          'eligibility.pre_assessment.invalid_amount.summary',
          {
            min: currency.format(min, true),
            max: currency.format(max, true)
          }
        )}
      />
    </DialogUnwrapped>
  )
}

export default InvalidAmount
